module.exports = __webpack_public_path__ + "img/gilles-beloeil-acu-ev-paintover-medieval-street-gbeloeil.d6f3e0a6.jpg";